import { apiGet } from '../../api'

export const get_task = id => {
  return apiGet({
    endpoint: `events/get_event?id=${id}`
  })
}
